"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _search = _interopRequireDefault(require("@/components/college/search.vue"));
var _courseItem = _interopRequireDefault(require("@/components/college/courseItem.vue"));
var _index = require("@/api/college/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseItem: _courseItem.default,
    Search: _search.default
  },
  props: {},
  data: function data() {
    return {
      query: {
        pageNum: 1,
        pageSize: 18,
        courseName: '',
        majorName: ''
      },
      total: 0,
      openCourse: []
    };
  },
  created: function created() {
    this.getopenCourse();
  },
  methods: {
    toSsearch: function toSsearch(e) {
      // console.log('dianji',e)
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
      this.getopenCourse();
    },
    getopenCourse: function getopenCourse() {
      var _this = this;
      (0, _index.peCourseList)({
        courseTypeList: ['3', '2', '6', '4', '5'],
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize,
        provinceId: this.$store.getters.provinceId,
        schoolId: this.$store.getters.wShoolInfo.id,
        showStatus: "1",
        courseName: this.query.courseName,
        majorName: this.query.majorName
      }).then(function (res) {
        if (res.code === 2000) {
          for (var i in res.data.list) {
            if (res.data.list[i].courseType == "3") {
              _this.$set(res.data.list[i], 'courseTypeName', '国家规划教材数字课程');
            } else if (res.data.list[i].courseType == "2") {
              _this.$set(res.data.list[i], 'courseTypeName', '课程思政示范项目');
            } else if (res.data.list[i].courseType == "6") {
              _this.$set(res.data.list[i], 'courseTypeName', '公共基础课');
            } else if (res.data.list[i].courseType == "5") {
              _this.$set(res.data.list[i], 'courseTypeName', '教学能力大赛获奖课程');
            } else if (res.data.list[i].courseType == "4") {
              _this.$set(res.data.list[i], 'courseTypeName', '班主任大赛获奖课程');
            }
          }
          _this.openCourse = res.data.list;
          _this.total = res.data.total;
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getopenCourse();
    }
  }
};